import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: [ './loading-screen.component.scss' ]
})
export class LoadingScreenComponent implements OnInit {
  loadingEllipsis: Observable<string> = timer(0, 500).pipe(map((count: number) => '.'.repeat(count % 4)));

  constructor() {}

  ngOnInit(): void {}
}
